import { AllEnvironmentName, EnvironmentName, LocalEnvironmentName } from "./environments.js";

export const CHROME_EXTENSION_IDS: Readonly<Record<AllEnvironmentName | "prod_emergency_fallback", string>> = {
    [EnvironmentName.PROD]: "hlkiignknimkfafapmgpbnbnmkajgljh",
    prod_emergency_fallback: "hkdmojfghhcobkbcbafakpeeebioiomm",
    [LocalEnvironmentName.LOCAL]: "aapocclcgogkmnckokdopfmhonfmgoek",
    [LocalEnvironmentName.LOCAL2]: "oepieljboffnihanklinondnbanaiecn",
    [EnvironmentName.KAPPA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.ALPHA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.BETA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.GAMMA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.DELTA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.EPSILON]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.LAMBDA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.OMEGA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.ZETA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.SIGMA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.THETA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.IOTA]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.PSI]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.NU]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.MU]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.CHI]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.RHO]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.FAKER]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.OMICRON]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.UMI]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.HADES]: "feiclbomfllbkdmeibcljmfbdakimmdg",
    [EnvironmentName.VOLDEMORT]: "feiclbomfllbkdmeibcljmfbdakimmdg",
};

/**
 * Chrome extension IDs for Waalaxy Companion (separate from the main Mew extension).
 * IDs are assigned by the Chrome Web Store once published; until then, load the unpacked
 * build and paste the ID from chrome://extensions into the LOCAL entry.
 */
export const SALES_NAV_EXTENSION_IDS: Readonly<Partial<Record<AllEnvironmentName, string>>> = {
    [LocalEnvironmentName.LOCAL]: "",
    [EnvironmentName.PROD]: "",
};

export const ALIEN_RECRUITER_EXTENSION_ID = "hclnipmjcchnmkceoamfmhnelkblhija";
